import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function FocusAreas() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center" data-id="element-39" data-mp="2arrwxmplye9d">
      <div className="w-full max-w-6xl" data-id="element-40" data-mp="2au5t5yw0xwii">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 sm:gap-16 md:gap-8 relative" data-id="element-41" data-mp="2oqj7iz59hhsr">
          {/* Desktop Dividers */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/3 w-px bg-brand-gold/20 -translate-x-1/2" data-id="element-42" data-mp="qe12bwy47ocb" />
          <div className="hidden md:block absolute top-0 bottom-0 left-2/3 w-px bg-brand-gold/20 -translate-x-1/2" data-id="element-43" data-mp="3rsh5pbwzkapq" />

          {/* Mobile Dividers */}

          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-44" data-mp="5mbsslz1eebq">
            <h3 className="font-heading text-sm sm:text-base tracking-widest uppercase text-brand-gold mb-4 sm:mb-8" data-id="element-45" data-mp="fcx1514iix7u">
              Media
            </h3>
            <p className="font-heading text-lg sm:text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-46" data-mp="jd78ah41jtoa">
              Backing projects that shape culture
            </p>
          </motion.div>

          <div className="block md:hidden w-12 h-px bg-brand-gold/20 mx-auto" data-id="element-47" data-mp="tbwlvxowmryq" />

          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-48" data-mp="2q6j0z7p9mpw6">
            <h3 className="font-heading text-sm sm:text-base tracking-widest uppercase text-brand-gold mb-4 sm:mb-8" data-id="element-49" data-mp="2n3d4eonjbn4w">
              Technology
            </h3>
            <p className="font-heading text-lg sm:text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-50" data-mp="2j3kvuby55gzj">
              Early-stage and emerging infrastructure
            </p>
          </motion.div>

          <div className="block md:hidden w-12 h-px bg-brand-gold/20 mx-auto" data-id="element-51" data-mp="2s4ss6oh3k7qz" />

          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-52" data-mp="360eh6vnbyrje">
            <h3 className="font-heading text-sm sm:text-base tracking-widest uppercase text-brand-gold mb-4 sm:mb-8" data-id="element-53" data-mp="3fsk3boqwieqo">
              Opportunistic Investments
            </h3>
            <p className="font-heading text-lg sm:text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-54" data-mp="3pq80elbzbyc0">
              High-conviction, asymmetric opportunities
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}